import React from 'react';
import { Link } from 'react-router-dom';
import { useConfiguration, useLocale } from '@gov-nx/core/service';
import type { ServiceCode } from '@gov-nx/module/service';
import { Button, ContentLayout, InfoBanner } from '@gov-nx/ui/web';

type GunListEmptyStateProps = {
	code: ServiceCode;
};

export const GunListEmptyState = ({ code }: GunListEmptyStateProps) => {
	const { portalMinisterstvaVnitraUrl } = useConfiguration();
	const { t } = useLocale(code);
	return (
		<ContentLayout>
			<InfoBanner
				headline={t('stav.chyba.zadny-zbrojni-list')}
				text={
					<>
						<div className="mb-(--spacing-m)!">
							{t('stav.chyba.zadny-zbrojni-list-popis')}
						</div>
						<Button
							color="primary"
							size="s"
							type="solid"
							asChild>
							<Link
								to={portalMinisterstvaVnitraUrl}
								target="_blank">
								{t('stav.chyba.zadny-zbrojni-list-akce')}
							</Link>
						</Button>
					</>
				}
			/>
		</ContentLayout>
	);
};
